/* eslint-disable func-names */
/* eslint-disable no-useless-escape */
(function (win, lib) {
    const doc = win.document;
    const docEl = doc.documentElement;
    let metaEl = doc.querySelector('meta[name="viewport"]');
    const flexibleEl = doc.querySelector('meta[name="flexible"]');
    let dpr = 0;
    let scale = 0;
    let tid;
    const flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        // console.warn('将根据已有的meta标签来设置缩放比例');
        const match = metaEl.getAttribute("content").match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        const content = flexibleEl.getAttribute("content");
        if (content) {
            const initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            const maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        // var isAndroid = win.navigator.appVersion.match(/android/gi);
        const isIPhone = win.navigator.appVersion.match(/iphone/gi);
        const { devicePixelRatio } = win;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute("data-dpr", dpr);
    if (!metaEl) {
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        metaEl.setAttribute("content", `initial-scale=${scale}, maximum-scale=${scale}, minimum-scale=${scale}, user-scalable=no`);
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            const wrap = doc.createElement("div");
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem() {
        let { width } = docEl.getBoundingClientRect();

        // 默认

        // 当屏幕超过1920px以后就不在随着屏幕的变大而变大了
        if (width / dpr > 1920) {
            width = 1920;
        }

        // 当屏幕小于1300px以后就不再随着屏幕的变小而变小了
        if (width / dpr < 1500) {
            width = 1500;
        }
        const rem = width / 10;

        docEl.style.fontSize = `${rem}px`;
        flexible.rem = win.rem = rem;
    }

    win.addEventListener(
        "resize",
        () => {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 0);
        },
        false
    );
    win.addEventListener(
        "pageshow",
        (e) => {
            if (e.persisted) {
                clearTimeout(tid);
                tid = setTimeout(refreshRem, 0);
            }
        },
        false
    );

    if (doc.readyState === "complete") {
        doc.body.style.fontSize = `${14 * dpr}px`;
    } else {
        doc.addEventListener(
            "DOMContentLoaded",
            () => {
                doc.body.style.fontSize = `${14 * dpr}px`;
            },
            false
        );
    }

    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    // eslint-disable-next-line func-names
    flexible.rem2px = function (d) {
        let val = parseFloat(d) * this.rem;
        if (typeof d === "string" && d.match(/rem$/)) {
            val += "px";
        }
        return val;
    };
    // eslint-disable-next-line func-names
    flexible.px2rem = function (d) {
        let val = parseFloat(d) / this.rem;
        if (typeof d === "string" && d.match(/px$/)) {
            val += "rem";
        }
        return val;
    };
})(window, window.lib || (window.lib = {}));
